import {Component, OnDestroy} from "@angular/core";
import {FeatureToggleModule} from "ngx-feature-toggle";
import {Subscription} from "rxjs";
import {FeatureToggleService} from "../..";

/**
 * @description
 *  feature toggle based on https://github.com/willmendesneto/ngx-feature-toggle
 *
 * ### Example
 *  ```
 *    <tart-feature-toggle>
           <div *featureToggle="'sso.LoginBtn'">sso.LoginBtn</div>
           <div *featureToggle="'sso.BackgroundImg'">sso.BackgroundImg</div>
           <div *featureToggle="'sso.LoginText'">sso.LoginText</div>
        </tart-feature-toggle>
    ```
 */

@Component({
  selector: 'tart-feature-toggle',
  standalone: true,
  imports: [FeatureToggleModule],
  template: `
      <feature-toggle-provider [features]="features">
        <ng-content></ng-content>
      </feature-toggle-provider>
  `
})
export class FeatureToggleComponent implements OnDestroy{
  features;
  subscriptions: Subscription[] = [];
  constructor(){
    this.subscriptions.push(FeatureToggleService.features.subscribe(res=>{
      this.features = res;
    }))
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub=>sub.unsubscribe())
  }
}
